import { FC } from 'react';
import { CollectionInfoContent } from '../../../CollectionInfoContent/CollectionInfoContent';
import { BookmarkStep } from '../../types';
import { ExistentCollectionContent } from '../ExistentCollectionContent/ExistentCollectionContent';
import { SaveToCollectionContentProps } from './types';

export const SaveToCollectionContent: FC<SaveToCollectionContentProps> = ({
    step,
    collections,
    isCollectionsLoading,
    onSaveToExistentCollection,
    onAddClick,
    onClose,
    values,
    handlers,
    isFavoritesEnabled,
}) => {
    if (step === BookmarkStep.ADD_TO_EXIST_COLLECTION) {
        return (
            <ExistentCollectionContent
                onClose={onClose}
                collections={collections}
                isCollectionsLoading={isCollectionsLoading}
                onAddClick={onAddClick}
                onSaveClick={onSaveToExistentCollection}
                isFavoritesEnabled={isFavoritesEnabled}
            />
        );
    }

    if (step === BookmarkStep.ADD_TO_NEW_COLLECTION) {
        return <CollectionInfoContent values={values} handlers={handlers} />;
    }

    return null;
};
